module.exports = __webpack_public_path__ + "static/media/NotoKufiArabic-Regular.8d2397d1.woff";